module.exports = __webpack_public_path__ + "img/_54A2271.81ce25f6.jpg";